export default function StatsSection() {
  const stats = [
    { number: '71+', label: 'Project done' },
    { number: '147+', label: 'Trusted partnership' },
    { number: '500+', label: 'Payment method' },
    { number: '7+', label: 'Years Experience' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-fade-in-up border border-gray-100"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="text-5xl font-bold text-teal-600 mb-3">{stat.number}</div>
              <div className="text-gray-700 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
